import { createInertiaApp } from "@inertiajs/react";
import * as Sentry from "@sentry/react";
import type { ComponentType } from "react";
import { createElement } from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import "../styles/application.css";

const sentryDsn = document.querySelector<HTMLMetaElement>('meta[name="sentry-dsn"]')?.content;
const sentryEnvironment =
  document.querySelector<HTMLMetaElement>('meta[name="sentry-environment"]')?.content || import.meta.env.MODE;

if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: sentryEnvironment,
    sendDefaultPii: false,
    tracesSampleRate: 0,
  });
}

createInertiaApp({
  resolve: (name) => {
    const pages = import.meta.glob<{ default: ComponentType }>("../pages/**/*.tsx", { eager: true });
    const page = pages[`../pages/${name}.tsx`];

    if (!page) {
      throw new Error(`Missing Inertia page: ${name}`);
    }

    return page;
  },
  setup({ el, App, props }) {
    const app = createElement(App, props);

    if (el.dataset.serverRendered === "true") {
      hydrateRoot(el, app);
      return;
    }

    createRoot(el).render(app);
  },
});
